import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { buildUriForCall } from '@/helpers/functions/buildUri'
import { Message } from 'element-ui'

export default {
  namespaced: true,
  state: {
    loadingReportDiffusion: false,
    filtersActive: false,
    filters: {
      active: true,
      search: '',
      page: 1,
      offset: 0,
      category: null,
      gratuit: '',
      limit: 10
    },
    results: [],
    total: 0,
    statistics: {
      dateDerniereMajAnnonces: '',
      nbPortailsActifs: 0,
      nbPortailsTotal: 0,
      pourcentageAnnoncesDiffusees: 0
    },
    pourcentageTotalDiffusion: 0,
    loadingPourcentageReportDiffusion: false,
    diffuseurs: [],
    logos: {},
    messagesExports: []
  },
  getters: {
    getLoadingReportDiffusion: (state) => state.loadingReportDiffusion,
    getReportDiffusion: (state) => state.results,
    getTotalReportDiffusion: (state) => state.total,
    getFilters: (state) => state.filters,
    getPage: (state) => state.filters.page,
    getOffset: (state) => state.filters.offset,
    getLimit: (state) => state.filters.limit,
    getStatisticsDateDerniereMajAnnonces: (state) => state.statistics.dateDerniereMajAnnonces,
    getStatisticsNbPortailsActifs: (state) => state.statistics.nbPortailsActifs,
    getStatisticsNbPortailsTotal: (state) => state.statistics.nbPortailsTotal,
    getStatisticsPourcentageAnnoncesDiffusees: (state) => state.statistics.pourcentageAnnoncesDiffusees,
    getLogoByPortal: (state) => (partnerCode) => state.logos[partnerCode],
    getMessagesExportDiffusion: (state) => state.messagesExports,
    getPourcentageTotalDiffusion: (state) => state.pourcentageTotalDiffusion,
    getLoadingPourcentageTotalDiffusion: (state) => state.loadingPourcentageReportDiffusion
  },
  actions: {
    loadExcludedCodeNames ({ commit }) {
      commit('setLoadingDiffusion', true)
      const url = '/diffuseurs'
      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then(response => {
          commit('setExcludedCodeNames', response.data)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          commit('setLoadingDiffusion', false)
        })
    },
    loadEnteteStatistics ({ commit, rootState }) {
      commit('setLoadingDiffusion', true)
      const advertiser = rootState.app.user.advertiser
      const url = `/annonceur-rapport-global?id=${advertiser}`
      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then(response => {
          commit('setStatistics', response.data)
        }).catch((error) => {
          console.log(error)
        }).finally(() => {
          commit('setLoadingDiffusion', false)
        })
    },
    loadRapportGlobalDiffusion ({ state, commit, dipatch, rootState }) {
      const portalCodeNames = {}
      const portalCodeLogs = {}
      const advertiser = rootState.app.user.advertiser
      const path = '/diffuseurs/annonceur'
      const filters = {
        name: state.filters.search,
        modelEco: state.filters.gratuit,
        category: state.filters.category
      }
      const url = buildUriForCall(path, filters)
      commit('setLoadingDiffusion', true)
      HTTP_HYPER_ESPACE_BACKEND.get(url)
        .then(response => {
          if (response.status === 200) {
            const data = response.data
            const diffuseurs = data._embedded.diffusion_annonceur
            diffuseurs.forEach((diffuseur) => {
              const nomDeCode = diffuseur.diffuseurNomDeCode
              const id = diffuseur.diffuseurId
              const logo = diffuseur._embedded.diffuseur.logo
              portalCodeNames[id] = nomDeCode
              portalCodeLogs[nomDeCode] = logo
            })
            commit('setPartnerCodeNames', portalCodeNames)
            commit('setPartnerCodeLogos', portalCodeLogs)
            const partnerCodeNames = Object.values(state.filters.portalCodeNames).join(',')
            commit('setLoadingDiffusion', true)
            const uri = '/rapports-diffusions-erreurs'
            const params = {
              idAdvertisers: advertiser,
              idAdvertiser: advertiser,
              page: 1,
              size: 500,
              type: 'DIFFUSION',
              partnerCodeName: partnerCodeNames,
              sort: 'endDate',
              direction: 'desc'
            }
            const url = buildUriForCall(uri, params)
            HTTP_HYPER_ESPACE_BACKEND.get(url)
              .then(response => {
                if (response.status === 200 && 'hits' in response.data) {
                  const portals = response.data.hits
                  commit('setCountResults', Object.keys(response.data.hits).length)
                  commit('setResults', portals)
                  return response.data.hits
                } else {
                  commit('setCountResults', response.data.length)
                  commit('setResults', response.data)
                }
              }).catch((error) => {
                console.log(error)
              }).finally(() => {
                commit('setLoadingDiffusion', false)
              })
          }
        }).catch((error) => {
          console.log(error)
        })
    },
    exporterDiffusion ({ state, commit }) {
      const results = Object.values(state.results)
      const exportMessages = []
      results.forEach((partner) => {
        const result = partner.messages.map(item => ({
          portail: item.nomCodeFluxPartenaire,
          referenceAnnonce: item.annonce,
          codeInterne: item.codeInterne,
          date: item.date,
          message: item.message
        }))
        exportMessages.push(result)
      })
      commit('setMessagesExport', exportMessages.flat())
    },
    loadPourcentageTotalDiffusion ({ state, commit }) {
      commit('setLoadingPourcentageTotalDiffusion', true)
      HTTP_HYPER_ESPACE_BACKEND('/pourcentage-total-diffusion')
        .then((response) => {
          const data = response.data
          // Pourcentage de diffusion des annonces (Portails avec des diffusions)
          if (data.totalPourcentageDiffusion > 0) {
            commit('setPourcentageTotalDiffusion', response.data.totalPourcentageDiffusion)
          }
        })
        .catch(() => {
          Message.error('serverError500')
        }).finally(() => {
          commit('setLoadingPourcentageTotalDiffusion', false)
        })
    }
  },
  mutations: {
    setFilters (state, { key, value }) {
      state.filters[key] = value
    },
    setResetFilters (state) {
      state.filters.active = true
      state.filters.search = ''
      state.filters.page = 1
      state.filters.offset = 0
      state.filters.category = null
      state.filters.gratuit = null
      state.filters.limit = 10
    },
    setLoadingDiffusion (state, bool) {
      state.loadingReportDiffusion = bool
    },
    setPartnerCodeNames (state, data) {
      state.filters.portalCodeNames = data
    },
    setPartnerCodeLogos (state, data) {
      state.logos = data
    },
    setExcludedCodeNames (state, data) {
      state.filters.excludedCodeNames = data
    },
    setMessagesExport (state, data) {
      state.messagesExports = data
    },
    setFiltersActive (state, bool) {
      state.filtersActive = bool
    },
    setResults (state, results) {
      state.results = results
    },
    setCountResults (state, count) {
      state.total = count
    },
    setStatistics (state, statistics) {
      Object.assign(state.statistics, statistics)
    },
    setPourcentageTotalDiffusion (state, stats) {
      state.pourcentageTotalDiffusion = stats
    },
    setLoadingPourcentageTotalDiffusion (state, bool) {
      state.loadingPourcentageReportDiffusion = bool
    }
  }
}
